import { Stack } from "@mui/material";
import { BudgetDetailsDetailsSection } from "./details-section/BudgetDetailsDetailsSection";
import { BudgetDetailsAccumulatedCostSection } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/accumulated-cost-section/BudgetDetailsAccumulatedCostSection";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsPeriodSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsPeriodSelector";
import { BudgetDetailsHistorySection } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/components/body/history-section/BudgetDetailsHistorySection";
import { budgetDetailsNotStartedSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsNotStartedSelector";

export const BudgetDetailsBody = () => {
  const period = useAppSelector(budgetDetailsPeriodSelector);
  const notStarted = useAppSelector(budgetDetailsNotStartedSelector);

  return (
    <Stack
      bgcolor="grey.100"
      p={1.5}
      spacing={1.5}
      height="100%"
      overflow="auto"
    >
      {period !== "daily" && <BudgetDetailsAccumulatedCostSection />}
      {period !== "custom" && !notStarted && <BudgetDetailsHistorySection />}
      <BudgetDetailsDetailsSection />
    </Stack>
  );
};
